import { render } from "./IconElectraWeightBike.vue?vue&type=template&id=ad3d4806"
import script from "./IconElectraWeightBike.vue?vue&type=script&lang=js"
export * from "./IconElectraWeightBike.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__